<template>
  <div class="dynamics-fiat-modal">
    <div v-if="asset" class="fiat-modal-body">
      <div
        :style="{
          textAlign:'center',
          width: '348px',
          alignSelf: 'center',
      }"
      >
        <div
          :style="{
            fontSize: '20px',
            fontWeight:'bold',
            lineHeight: '24px',
            color: '#333333',
            marginBottom: '18px'
        }"
        >
          {{asset.fullName}}({{asset.name}})
          <br />Fiat Deposit Instructions
        </div>
        <div
          :style="{
            fontSize: '12px',
            fontWeight:'bold',
            lineHeight: '14px',
            color: 'red',
            marginBottom: '18px'
        }"
        >! CRITICAL INFORMATION !</div>
        <div
          :style="{
            fontSize: '12px',
            lineHeight: '14px',
            color: 'red',
            marginBottom: '18px'
        }"
        >You must include your user ID information in the reference section of the wire transfer. Crypto Swap Limited will not be held responsible for funds that arrive in our account that do not bear the USERS ACCOUNT ID</div>
      </div>
      <div
        v-for="(group, index) in [
            { 
                title: 'WIRE TRANSFER COORDINATES',
            },
            { 
                title: 'BENEFICIARY',
                children: [
                    ['Name', '10772208 Canada Corp.'],
                    ['Phone', '1 (647) 612-7729'],
                    ['Address', '44 Clare Ave \nWelland ON Canada L3C0B7'],
                ]
            },
            { 
                title: 'BENEFICIARY BANK',
                children: [
                    ['Name', 'Royal Bank of Canada'],
                    ['Address', '2947 Bloor St. West, Toronto, Ontario, Canada M8X 1B8'],
                    ['Account Number', asset.account],
                    ['Bank SWIFT BIC Code:', asset.swiftCode],
                    ['Canadian Sort Code:', asset.sortCode],
                    ['Wire Reference', $store.getters.currAccount.userid, 'color:red; margin: 10px 0;'],
                ]
            }
        ]"
        :key="`fiat-info-row-${index}`"
      >
        <div class="fiat-info-title">{{group.title}}</div>
        <div
          v-for="(item, index) in group.children"
          :key="`item-${index}`"
          :class="['fiat-info-row', 'js-copy-btn']"
          :data-clipboard-text="item[1]"
          @click="$Message.success('Copy successful')"
        >
          <div class="fiat-info-label" :style="item[2]">{{item[0]}}</div>
          <div v-if="item[1]" class="fiat-info-value" :style="item[2]">{{item[1]}}</div>
        </div>
      </div>
      <Button type="primary" @click="$emit('close')" class="fiat-confirm-btn">UNDERSTAND</Button>
    </div>
    <div class="fiat-modal-footer">
      <div class="fiat-modal-footer-row">○ Min deposit amount：50.00 {{asset.name}}</div>
      <div class="fiat-modal-footer-row">○ Deposit fee is 0.5%</div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";

const COIN_DIC = {
  73: {
    fullName: "Canadian Dollar",
    name: "CAD",
    account: "05602-1028299",
    swiftCode: "ROYCCAT2",
    sortCode: "CC 000305602"
  },
  74: {
    fullName: "Euro",
    name: "EUR",
    account: "05952-5005970",
    swiftCode: "ROYCCAT2",
    sortCode: "CC 000305952"
  },
  75: {
    fullName: "Great Britain Pounds",
    name: "GBP",
    account: "00724-5074505",
    swiftCode: "ROYCCAT2",
    sortCode: "CC 000300724"
  },
  76: {
    fullName: "Japanese Yen",
    name: "JPY",
    account: "00724-5038906",
    swiftCode: "ROYCCAT2",
    sortCode: "CC 000300724"
  }
};

export default {
  props: {
    currTarget: Object
  },
  computed: {
    asset() {
      return COIN_DIC[this.currTarget.id];
    }
  },
  mounted() {
    console.log({ coin: this.currTarget });
    this.$nextTick(() => {
      // eslint-disable-next-line
      new Clipboard(".js-copy-btn");
    });
  }
};
</script>
<style lang="less">
@import "../../../../static/style/color.less";
.dynamics-fiat-modal {
  width: 500px;
  color: @font-black;
  font-size: 12px;
  padding: 20px 40px 0;
  .fiat-modal-body {
    display: flex;
    flex-direction: column;
    color: rgba(133, 124, 124, 1);
    .fiat-info-title {
      font-size: 12px;
      line-height: 14px;
      text-decoration: underline;
      line-height: 3;
    }
    .fiat-info-row {
      cursor: pointer;
      display: flex;
      width: 100%;
      line-height: 22px;
      .fiat-info-label {
        width: 200px;
        color: #b8b8b8;
      }
      .fiat-info-value {
        width: 0;
        flex-grow: 1;
        font-weight: bold;
        color: @font-black;
        white-space: pre-wrap;
      }
    }
    .fiat-info-warning {
      margin: 8px 0;
      color: #ed4014;
    }
    .fiat-confirm-btn {
      border-radius: 20px;
      height: 40px;
      width: 370px;
      font-weight: bold;
      font-size: 16px;
      margin: 20px 0;
      align-self: center;
    }
  }

  .fiat-info-row:hover {
    opacity: 0.4;
  }
  .fiat-modal-footer {
    margin-bottom: 20px;
    .fiat-modal-footer-row {
      text-align: left;
      color: @light-grey-2;
      font-size: 12px;
      line-height: 16px;
      margin: 10px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/channel-specific/dynamics/fiatModal.vue